import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FieldsetContainer = styled.fieldset`
  margin-bottom: ${Spacing.S8};
  padding: 0;
`
